import { getMessages } from '../stateReader';
import { chatSdk } from '../../api/chat-sdk';
var getMessagesFromState = function () {
    return getMessages(chatSdk.store.getState()).byId;
};
var areAllMessagesNew = function (newMessages) {
    if (newMessages === void 0) { newMessages = []; }
    var messagesFromState = getMessagesFromState();
    return newMessages.every(function (message) { return messagesFromState[message.id] === undefined; });
};
export { areAllMessagesNew };
